import { Route } from '@angular/router';
import { MANAGE_PLAN_ROUTE } from '@rci/self-serve-fido/app.constant';
import { BreadcrumbsService } from '@rci/self-serve-fido/core/breadcrumbs/breadcrumbs.service';
import { ManagePlanConfigService, managePlanRoutes } from '@rogers/self-serve-wireless/plan';
import { ManagePlanAppConfigService } from './manage-plan-app.config.service';

export const managePlanAppRoute: Route = {
  path: MANAGE_PLAN_ROUTE,
  children: managePlanRoutes,
  providers: [
    {
      provide: ManagePlanConfigService,
      useClass: ManagePlanAppConfigService,
      deps: [BreadcrumbsService],
    },
  ],
};
